
import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
// import { ConfirmationComponent } from "../../../common/components/confirmation/confirmation.component";
import { AboutService } from "../about/about.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import Swal from "sweetalert2";
import { RESPONSE } from "src/app/common/common.const";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  // @ViewChild("myckeditorm") ckeditor: any;
  ckeConfig: any;

  id: string = '';
  type: number = 1;
  text: string = '';


  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };

  searchText: string = "";
  constructor(
    private modalService: NgbModal,
    private AboutService: AboutService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) { }
  ngOnInit() {
    this.getAboutdata();
  }

  getAboutdata() {
    let query = "status=1";

    this.AboutService.getAbout(query).subscribe(data => {
      if (data["message"] = "Success") {

        this.text = data.data[0].text;
        this.id = data.data[0]._id;
      }
    });

  }
  finalSubmit() {
    let value = {
      text: this.text,
      status: this.type
    }
    this.AboutService.saveAbout(value).subscribe(res => {
      if (res["message"] = "Success") {
        Swal.fire("Success", "Saved successfully!", "success");
      }
      else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }
}

